// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"a5cc7999","767":"208b8015"}[chunkId] + ".chunk.js";
};